import Vuex from "vuex";
import { createStore } from "vuex";

import ReOrder from "./modules/ReOrder";
import Auth from "./modules/Auth";
import Location from "./modules/Location";
import ProductItems from "./modules/ProductItems";
import Cart from "./modules/Cart";
import Config from "./modules/Config";
import User from "./modules/User";
import Favourite from "./modules/Favourite";
import Notification from "./modules/Notification";
import Offers from "./modules/Offers";
import PaymentOffers from "./modules/PaymentOffers";
import BannerOffers from "./modules/BannerOffers";
import Profile from "./modules/Profile";
import Menu from "./modules/Menu";
import ThankYou from "./modules/ThankYou";
import OrderTracking from "./modules/OrderTracking";
import Loader from "./modules/Loader";
import FingerPrint from "./modules/FingerPrint";
import CartPayment from "./modules/CartPayment";
import MultipleRecommendation from "./modules/MultipleRecommendation";
import NotifyToast from "./modules/NotifyToast";
import CsatFeedback from "./modules/CsatFeedback";
import WalletInfo from "./modules/WalletInfo";
import SavedPaymentModes from "./modules/SavedPaymentModes";

import GuestUser from "./modules/GuestUser";
import Global from "./modules/paymentModules/GlobalPayment";
import Address from "./modules/paymentModules/Address";
import Payments from "./modules/paymentModules/Payments";
import PriceDetail from "./modules/paymentModules/PriceDetail";
import NetBanking from "./modules/paymentModules/NetBanking";
import PaymentSubmit from "./modules/paymentModules/PaymentSubmit";
import PaytmWallet from "./modules/paymentModules/PaytmWallet";
import Upi from "./modules/paymentModules/Upi";
import Cash from "./modules/paymentModules/Cash";
import Wallet from "./modules/paymentModules/Wallet";
import CreditDebit from "./modules/paymentModules/CreditDebit";
import ErrorModal from "./modules/paymentModules/ErrorModal";
import GiftCardAndEvoucher from "./modules/paymentModules/GiftCardAndEvoucher";

export default createStore({
  state: {
    loading: false,
  },
  getters: {
    loading: (state) => state.loading,
  },
  mutations: {
    updateLoadingState(state, payload) {
      state.loading = payload;
    },
  },
  actions: {},
  modules: {
    ReOrder: ReOrder,
    Auth: Auth,
    Location: Location,
    ProductItems: ProductItems,
    Cart: Cart,
    Config: Config,
    User: User,
    Favourite: Favourite,
    Notification: Notification,
    Offers: Offers,
    PaymentOffers: PaymentOffers,
    BannerOffers: BannerOffers,
    Profile: Profile,
    ThankYou: ThankYou,
    Menu: Menu,
    OrderTracking: OrderTracking,
    Loader: Loader,
    FingerPrint: FingerPrint,
    CartPayment: CartPayment,
    MultipleRecommendation: MultipleRecommendation,
    NotifyToast: NotifyToast,
    CsatFeedback: CsatFeedback,
    WalletInfo: WalletInfo,
    SavedPaymentModes: SavedPaymentModes,
    //payment modules start
    Global: Global,
    Address: Address,
    Payments: Payments,
    PriceDetail: PriceDetail,
    NetBanking: NetBanking,
    PaymentSubmit: PaymentSubmit,
    PaytmWallet: PaytmWallet,
    Upi: Upi,
    Cash: Cash,
    Wallet: Wallet,
    CreditDebit: CreditDebit,
    ErrorModal: ErrorModal,
    GiftCardAndEvoucher: GiftCardAndEvoucher,
    //payment modules end
    GuestUser: GuestUser,
  },
});
